module.exports = __webpack_public_path__ + "static/img/1029.fc950d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1029.jpg
// module id = 211
// module chunks = 0